module.exports = __webpack_public_path__ + "static/media/arrows-rotate-regular.0b63e092.svg";